import React from 'react';
import { Container, Grid ,Typography} from '@material-ui/core/';

import './style.css';

function LearnMore() {
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    return (
        <Container className="notification-view">
            <Grid item sm={4} md={4} lg={4}></Grid>
            <Grid item sm={8} md={8} lg={8}>
                <Typography component="h3">Coming Soon</Typography>
            </Grid>
        </Container>
    );
}

export default LearnMore;
